import { clearNativeNotificationsForChat, clearNativeNotificationsForChats } from './nativePush'

type ClearForChatPayload = {
  type: 'clear-notifications-for-chat'
  chat_id: string
  topic_id: string | null
}

type ClearForChatsPayload = {
  type: 'clear-notifications-for-chats'
  chat_ids: string[]
  include_topic_notifications: boolean
}

function postToServiceWorker(payload: ClearForChatPayload | ClearForChatsPayload): void {
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) return
  const ctrl = navigator.serviceWorker.controller
  if (ctrl) {
    ctrl.postMessage(payload)
    return
  }
  navigator.serviceWorker.ready.then((reg) => {
    const sw = reg.active || reg.waiting || reg.installing
    sw?.postMessage(payload)
  }).catch(() => {})
}

export function clearReadNotificationsForChat(
  chatId: string,
  topicId: string | null,
  chatLabel?: string | null,
): void {
  void clearNativeNotificationsForChat(chatId, topicId, chatLabel).catch(() => {})
  postToServiceWorker({
    type: 'clear-notifications-for-chat',
    chat_id: chatId,
    topic_id: topicId,
  })
}

// Callers MUST only pass chat IDs whose server-confirmed unread count is 0.
// chat.unread is the rollup across every topic (chats.py:452-454), so
// unread === 0 mathematically guarantees every per-topic notification is
// also stale and safe to dismiss. The previous version kept topic
// notifications around — that path left stale topic-tagged notifications
// in the tray after Mark read the same message on another device.
export function clearReadNotificationsForChats(chatIds: string[]): void {
  const ids = Array.from(new Set(chatIds.filter(Boolean)))
  if (ids.length === 0) return
  void clearNativeNotificationsForChats(ids, { includeTopicNotifications: true }).catch(() => {})
  postToServiceWorker({
    type: 'clear-notifications-for-chats',
    chat_ids: ids,
    include_topic_notifications: true,
  })
}
